/**
 * 用于 window.open 打开本 SPA 时的 URL 前缀。
 * 生产环境在 Docker/README 中通过 VUE_APP_WEB_HOST 注入，格式须含 hash，例如：https://host/#（与 vue-router hash 模式一致）。
 * 若未配置，开发时常见为 undefined，拼接会得到 "undefined/clinic/..."；此处退回当前 origin + /#。
 *
 * @returns {string} 不含末尾路径，例如 http://localhost:8080/# 或 https://dashboard.xxx.com/#
 */
export function getAppWebBase () {
  const v = process.env.VUE_APP_WEB_HOST
  if (v != null && String(v).trim() !== '' && String(v) !== 'undefined') {
    return String(v).trim().replace(/\/+$/, '')
  }
  if (typeof window !== 'undefined' && window.location && window.location.origin) {
    return `${window.location.origin.replace(/\/+$/, '')}/#`
  }
  return ''
}

/**
 * 拼接可在新标签页打开的完整应用地址（hash 模式）。
 *
 * @param {string} pathWithQuery 路由路径及查询串，须以 / 开头，如 `/clinic/clinic_info?clinic_id=1&doctor_id=-1`
 * @returns {string} 完整 URL
 */
export function buildAppWebUrl (pathWithQuery) {
  const base = getAppWebBase()
  const path = pathWithQuery.startsWith('/') ? pathWithQuery : `/${pathWithQuery}`
  if (!base) {
    return path
  }
  if (base.includes('#')) {
    return `${base}${path}`
  }
  const b = base.replace(/\/+$/, '')
  return `${b}/#${path}`
}
